import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { toast } from "sonner";
import { ArrowLeft, Mail, ArrowRight } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/request-password-reset", { email: email.trim() });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally { setLoading(false); }
  }

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 flex items-center justify-center px-5">
      <div className="fixed inset-0 pointer-events-none -z-10">
        <div className="absolute top-0 -left-32 w-[500px] h-[500px] bg-emerald-500/15 rounded-full blur-3xl"/>
        <div className="absolute bottom-0 -right-32 w-[500px] h-[500px] bg-amber-500/10 rounded-full blur-3xl"/>
      </div>
      <div className="w-full max-w-md">
        <Link to="/login" className="inline-flex items-center gap-2 text-slate-400 hover:text-white text-sm mb-8">
          <ArrowLeft size={14}/> Torna al login
        </Link>

        <div className="text-[11px] tracking-[0.4em] text-emerald-400 uppercase font-bold mb-2">🔒 Password dimenticata</div>
        <h1 className="text-3xl sm:text-4xl font-black tracking-tight" data-testid="forgot-title">Reimposta la tua password</h1>

        {sent ? (
          <div className="mt-8 rounded-xl border border-emerald-500/40 bg-emerald-500/10 p-6" data-testid="forgot-sent-card">
            <Mail size={22} className="text-emerald-400 mb-3"/>
            <h2 className="font-bold text-lg text-white">Controlla la tua email</h2>
            <p className="mt-2 text-sm text-slate-300 leading-relaxed">
              Se l&apos;indirizzo <span className="font-mono text-emerald-300">{email}</span> è registrato,
              riceverai a breve una mail con le istruzioni per impostare una nuova password.
              Il link è valido per <span className="text-white font-bold">30 minuti</span>.
            </p>
            <div className="mt-4 text-xs text-slate-500">
              Non ricevi nulla? Controlla la cartella spam.
              Puoi <button onClick={() => { setSent(false); setEmail(""); }} className="text-emerald-400 hover:text-emerald-300 underline">richiedere un nuovo link</button>.
            </div>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="mt-8 space-y-4">
            <p className="text-sm text-slate-400">
              Inserisci l&apos;email del tuo account. Ti invieremo un link per impostare una nuova password.
            </p>
            <div>
              <label className="text-xs tracking-widest text-slate-400 uppercase font-bold block mb-2">📧 Email</label>
              <input data-testid="forgot-email"
                className="w-full bg-slate-900 border border-slate-700 rounded-md px-4 py-3 focus:border-emerald-500 focus:outline-none focus:ring-1 focus:ring-emerald-500 transition-colors"
                type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="tu@email.it"/>
            </div>
            <button type="submit" disabled={loading}
              data-testid="forgot-submit"
              className="w-full inline-flex items-center justify-center gap-2 px-4 py-3 rounded-md bg-emerald-500 hover:bg-emerald-400 text-slate-950 font-bold uppercase tracking-wider disabled:opacity-50 shadow-lg shadow-emerald-500/20 transition-all">
              {loading ? "Invio…" : "Invia link di reset"} <ArrowRight size={16}/>
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
